export interface SheetTemplate {
  code: string; // e.g., "Avery 6572"
  pageSizeIn: { w: number; h: number }; // 8.5 x 11 typical
  labelSizeIn: { w: number; h: number };
  columns: number;
  rows: number;
  leftMarginIn: number;
  topMarginIn: number;
  hSpacingIn: number;
  vSpacingIn: number;
  rotateCCW90OnSheet?: boolean;
}

type TemplateSpec = {
  code: string;
  sizeIn: { w: number; h: number };
  grid: { cols: number; rows: number };
  rotate?: boolean;
};

function buildSheet(spec: TemplateSpec): SheetTemplate {
  const page = { w: 8.5, h: 11 };
  const labelW = spec.sizeIn.w;
  const labelH = spec.sizeIn.h;
  const cols = spec.grid.cols;
  const rows = spec.grid.rows;
  let margin = 0.5; // start at 0.5in

  const totalLabelsW = cols * labelW;
  const totalLabelsH = rows * labelH;
  let hSpacing = (page.w - 2 * margin - totalLabelsW) / (cols - 1);
  let vSpacing = (page.h - 2 * margin - totalLabelsH) / (rows - 1);

  if (hSpacing < 0 || vSpacing < 0) {
    // Reduce margins equally until spacing clamps to zero
    const needW = Math.max(0, totalLabelsW - (page.w - 2 * margin));
    const needH = Math.max(0, totalLabelsH - (page.h - 2 * margin));
    const extra = Math.max(needW, needH) / 2;
    margin = Math.max(0, margin - extra);
    hSpacing = Math.max(0, (page.w - 2 * margin - totalLabelsW) / (cols - 1));
    vSpacing = Math.max(0, (page.h - 2 * margin - totalLabelsH) / (rows - 1));
  }

  return {
    code: spec.code,
    pageSizeIn: page,
    labelSizeIn: { w: labelW, h: labelH },
    columns: cols,
    rows: rows,
    leftMarginIn: margin,
    topMarginIn: margin,
    hSpacingIn: hSpacing,
    vSpacingIn: vSpacing,
    rotateCCW90OnSheet: Boolean(spec.rotate),
  };
}

const SPECS: TemplateSpec[] = [
  // Square
  { code: "Avery 22806", sizeIn: { w: 2, h: 2 }, grid: { cols: 3, rows: 4 }, rotate: false },
  { code: "Avery 22805", sizeIn: { w: 1.5, h: 1.5 }, grid: { cols: 4, rows: 6 }, rotate: false },
  { code: "Avery 5658", sizeIn: { w: 1, h: 1 }, grid: { cols: 6, rows: 8 }, rotate: false },
  // Rectangular (rotate on sheet)
  { code: "Avery 6572", sizeIn: { w: 2, h: 2.625 }, grid: { cols: 3, rows: 5 }, rotate: true },
  { code: "Avery 22828", sizeIn: { w: 1.25, h: 1.75 }, grid: { cols: 4, rows: 6 }, rotate: true },
  { code: "Presta 94219", sizeIn: { w: 1, h: 1.5 }, grid: { cols: 4, rows: 8 }, rotate: true },
];

export const SHEETS: SheetTemplate[] = SPECS.map(buildSheet);

export function inchesToPoints(inches: number): number {
  return inches * 72;
}

export function getSheetByCode(code: string): SheetTemplate {
  const s = SHEETS.find((x) => x.code === code);
  if (!s) throw new Error(`Unknown sheet code: ${code}`);
  return s;
}


